/**
 * `/code-review/comments` — *Feluda Comments* section.
 */
import { SettingsForm } from '../../components/SettingsForm.js';

export default function CodeReviewComments() {
  return (
    <main className="feluda-settings">
      <SettingsForm
        section="comments"
        title="Feluda Comments"
        subtitle="Calibrate how aggressively Feluda comments."
      />
    </main>
  );
}
